<app-filters-factoring
  (onEnter)="receiveFilterDate($event)"
  (geFilter)="receiveFilterCompany($event)"
  (siiFilter)="receiveChangeSiiFilter($event)"
  (pymeFilter)="receiveChangePymeFilter($event)"

></app-filters-factoring>

<main>
  <section class="container_first">
    <app-table-companies
      class="container-grill-accum"
      [recieveFilterName]="clientes"
      [booleanFlag]="booleanFlag"
      [booleanText]="booleanText"
      [pagedProviderSummaries]="clientes"
      (changePagination)="receiveProviderPaginationChange($event)"
      (changeSorting)="receiveChangeSortingOrder($event)"
      class="width-grill"
    ></app-table-companies>
    <!-- <app-factoring-monthly-amount
      class="container-charts"
      [dailyAmount]="dailyAmount"
      [recieveFilterDate]="sendDateFilter"
      [recieveFilterName]="sendNameFilter"
    ></app-factoring-monthly-amount> -->
  </section>
  <!-- <section class="container_first"> -->
    <!-- <app-factoring-factorizations
      class="container-grill"
      [booleanFlagCesionario]="booleanFlagCesionario"
      [cesionarioSummaries]="cesionarioSummaries"
      [recieveFilterDate]="sendDateFilter"
      [recieveFilterName]="cesionarioSummaries"
    ></app-factoring-factorizations> -->

    <!-- <app-factoring-docs
      class="container-charts"
      [dailyDocs]="dailyDocs"
      [recieveFilterDate]="sendDateFilter"
      [recieveFilterName]="sendNameFilter"
    ></app-factoring-docs> -->
  <!-- </section> -->
</main>
